import { render, staticRenderFns } from "./demandPayment.vue?vue&type=template&id=57cc23d6&"
import script from "./demandPayment.vue?vue&type=script&lang=js&"
export * from "./demandPayment.vue?vue&type=script&lang=js&"
import style0 from "./demandPayment.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "demandPayment.vue"
export default component.exports